import { IApplicationState } from '../../types/redux';

export const isDiscountMortgageBannerEnabled = (state: IApplicationState): boolean => {
  return state.config.isDiscountMortgageBannerEnabled;
};
